import globalIP from '@/GlobelIP';
import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import {
  Breadcrumb,
  Button,
  CheckPicker,
  Col,
  Divider,
  Drawer,
  FlexboxGrid,
  Loader,
  Panel,
  Stack,
  InputGroup,
  Input
} from 'rsuite';
import {
  fetchColors,
  fetchFinishes,
  fetchHsn,
  fetchMaterials,
  fetchCategory,
  fetchSkuUnique,
  fetchAlias,
  fetchBuyers,
  fetchMadeBy,
  fetchHeads,
  fetchProductLabel,
  fetchProductDesign,
  fetchProductName,
  fetchSearchKeyword,
  fetchProductTypes
} from '../../../apiService/apiService';
import NavD from './NavD';
import { useInView } from 'react-intersection-observer';
import ugr from '@/UGRoute';
import SearchIcon from '@rsuite/icons/Search';
import HeaderFilter from '@/components/HeaderFilter';
import FilterDrawer from '@/components/FilterDrawer';
import ProductCard from '@/components/ProductSearchPage/ProductCard';
import UndoIcon from '@rsuite/icons/Undo';
import useFilter from '../members/Filters';
import { Dropdown } from 'antd';
import { EyeFilled } from '@ant-design/icons';
interface PaginationData {
  page: number;
  pageSize: number;
  pageCount: number;
  total: number;
}
interface MetaData {
  pagination: PaginationData;
}
interface RowDataCollection {
  id: string; // or number, depending on your data
  attributes: {
    MatCollectionCode: string;
    MatCollectionName: string;
  };
}
const Library = ({ activeKey, handleNavSelect, label }) => {
  const [showSearch, setShowSearch] = useState(false);
  const [showPanel, setShowPanel] = useState(true);
  const [matname, setMatName] = useState('');
  const [matTitle, setMatTitle] = useState('');
  const handlePanelToggle = (mtname, title) => {
    setShowSearch(true);
    setMatName(mtname);
    setMatTitle(title);
    setShowPanel(!showPanel);
  };
  const handlePanelToggleBack = () => {
    setShowPanel(!colLoading);
  };
  const [limit, setLimit] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedCategory, setSelectedCategory] = useState([]);
  const [selectedProductType, setSelectedProductType] = useState([]);
  const [selectedColor, setSelectedColor] = useState([]);
  const [selectedFinish, setSelectedFinish] = useState([]);
  const [selectedhsn, setSelectedhsn] = useState([]);
  const [selectedmaterial, setSelectedmaterial] = useState([]);
  const [selectedBuyer, setSelectedBuyer] = useState([]);
  const [selectedSearch, setSelectedSearch] = useState([]);
  const [selectedAlias, setSelectedAlias] = useState([]);
  const [selectedpron, setSelectedPron] = useState([]);
  const [selectedpd, setSelectedProd] = useState([]);
  const [selectedmade, setSelectedMade] = useState([]);
  const [selectedsku, setSelectedSku] = useState([]);
  const [meta123, setMeta123] = useState<MetaData>();
  const [selectedCategoryCode, setSelectedCategoryCode] = useState([]);
  const [data123, setData123] = useState([]);
  const [isLoadmdata, setIsLoadmdata] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [clearSearchQuery, setClearSearchQuery] = useState(false);
  const history = useNavigate();


  const [selectedDateRange, setSelectedDateRange] = useState(null);
  const [selectedUpdatedDateRange, setSelectedUpdatedDateRange] = useState(null);
  const handleDatechange = value => {
    setCurrentPage(1)
    setData123([]);
    setSelectedDateRange(value);
  };
  const handleUpdatedDatechange = value => {
    setCurrentPage(1)
    setData123([]);
    setSelectedUpdatedDateRange(value);
  };


  const { ref, inView } = useInView({
    rootMargin: `0px 0px ${700}px 0px`
  });
  // useEffect for clearing searchQuery
  useEffect(() => {
    if (clearSearchQuery) {
      fetchDatar();
      //  TableFetchData();
    }
  }, [clearSearchQuery]);

  const [debouncedSearchQuery, setDebouncedSearchQuery] = useState(searchQuery);

  // Debounce effect for searchQuery
  useEffect(() => {
    setCurrentPage(1);
    const timer = setTimeout(() => {
      setDebouncedSearchQuery(searchQuery);
    }, 500); // Adjust the debounce delay as needed

    return () => clearTimeout(timer); // Cleanup the timeout if searchQuery changes before the delay
  }, [searchQuery]);

  // Effect that triggers on debouncedSearchQuery
  useEffect(() => {
    // console.log('searchQuery', debouncedSearchQuery);
    //  setPage(1);
    fetchDatar(); // Your data fetching function
    //  TableFetchData();  // Another data fetching function
  }, [debouncedSearchQuery]); // This effect now triggers when debouncedSearchQuery changes

  useEffect(() => {
    if (matname) {
      fetchDatar();
    }
  }, [
    matname,
    selectedCategory,
    selectedProductType,
    selectedDateRange,
    selectedUpdatedDateRange,
    selectedColor,
    selectedFinish,
    selectedhsn,
    selectedmaterial,
    selectedBuyer,
    selectedSearch,
    selectedAlias,
    selectedpron,
    selectedpd,
    selectedmade,
    selectedsku,
    currentPage
  ]);
  const formatDateToISO = date => date.toISOString();

  const getFirstDayOfWeek = date => {
    const firstDay = new Date(date);
    firstDay.setDate(date.getDate() - firstDay.getDay()); // Sunday is the first day of the week
    firstDay.setHours(0, 0, 0, 0);
    return formatDateToISO(firstDay);
  };

  const getFirstDayOfMonth = date => {
    const firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
    firstDay.setHours(0, 0, 0, 0);
    return formatDateToISO(firstDay);
  };

  const getFirstDayOfLastMonth = date => {
    const firstDayOfLastMonth = new Date(date.getFullYear(), date.getMonth() - 1, 1);
    firstDayOfLastMonth.setHours(0, 0, 0, 0);
    return formatDateToISO(firstDayOfLastMonth);
  };

  const getLastDayOfLastMonth = date => {
    const lastDayOfLastMonth = new Date(date.getFullYear(), date.getMonth(), 0);
    lastDayOfLastMonth.setHours(23, 59, 59, 999);
    return formatDateToISO(lastDayOfLastMonth);
  };

  const getDateDaysAgo = (date, days) => {
    const result = new Date(date);
    result.setDate(date.getDate() - days);
    result.setHours(0, 0, 0, 0);
    return formatDateToISO(result);
  };
  const fetchDatar = async () => {
    if (isLoadmdata) {
      return;
    }
    setIsLoadmdata(true);
    try {
      let categoryFilter = '';
      if (selectedCategory.length > 0) {
        const categoryFilterString = selectedCategory
          .map(cat => `filters[CategoryCode][$eq]=${cat}`)
          .join('&');
        categoryFilter = `&${categoryFilterString}`;
      }
      let protypeFilter = '';
      if (selectedProductType.length > 0) {
        const protypeFilterString = selectedProductType
          .map(pro => `filters[ProductTypeCode][$eq]=${pro}`)
          .join('&');
        protypeFilter = `&${protypeFilterString}`;
      }
      let colorFilter = '';
      if (selectedColor.length > 0) {
        const colorFilterString = selectedColor
          .map(color => `filters[ColorCode][$eq]=${color}`)
          .join('&');
        colorFilter = `&${colorFilterString}`;
      }
      let finishFilter = '';
      if (selectedFinish.length > 0) {
        const finishFilterString = selectedFinish
          .map(finish => `filters[FinishCode][$eq]=${finish}`)
          .join('&');
        finishFilter = `&${finishFilterString}`;
      }
      let hsnFilter = '';
      if (selectedhsn.length > 0) {
        const hsnFilterString = selectedhsn.map(hsn => `filters[HSNCode][$eq]=${hsn}`).join('&');
        hsnFilter = `&${hsnFilterString}`;
      }
      let matFilter = '';
      if (selectedmaterial.length > 0) {
        const matFilterString = selectedmaterial
          .map(mat => `filters[ProductionDetail[0].MaterialCode][$eq]=${mat}`)
          .join('&');
        matFilter = `&${matFilterString}`;
      }
      let buyerFilter = '';
      if (selectedBuyer.length > 0) {
        const buyerFilterString = selectedBuyer
          .map(buyer => `filters[BuyerName][$eq]=${buyer}`)
          .join('&');
        buyerFilter = `&${buyerFilterString}`;
      }
      let searchFilter = '';
      if (selectedSearch.length > 0) {
        const SearchFilterString = selectedSearch
          .map(search => `filters[SearchKeyword][$eq]=${search}`)
          .join('&');
        searchFilter = `&${SearchFilterString}`;
      }
      let aliasFilter = '';
      if (selectedAlias.length > 0) {
        const aliasFilterString = selectedAlias
          .map(alias => `filters[ProductId][$eq]=${alias}`)
          .join('&');
        aliasFilter = `&${aliasFilterString}`;
      }
      let pronFilter = '';
      if (selectedpron.length > 0) {
        const pronFilterString = selectedpron
          .map(pron => `filters[ProductName][$eq]=${pron}`)
          .join('&');
        pronFilter = `&${pronFilterString}`;
      }
      let prodFilter = '';
      if (selectedpd.length > 0) {
        const prodFilterString = selectedpd
          .map(prod => `filters[ProductDesigner][$eq]=${prod}`)
          .join('&');
        prodFilter = `&${prodFilterString}`;
      }
      let madeFilter = '';
      if (selectedmade.length > 0) {
        const madeFilterString = selectedmade.map(made => `filters[MadeBy][$eq]=${made}`).join('&');
        madeFilter = `&${madeFilterString}`;
      }
      let skuFilter = '';
      if (selectedsku.length > 0) {
        const skuFilterString = selectedsku.map(sku => `filters[BuyerSku][$eq]=${sku}`).join('&');
        skuFilter = `&${skuFilterString}`;
      }
      let searchQryFilter = '';
      if (searchQuery.length > 0) {
        let searchQryy = searchQuery.trim();
        const searchQry = `filters[$or][0][ProductId][$containsi]=${searchQryy}&filters[$or][1][ProductName][$containsi]=${searchQryy}&filters[$or][2][SearchKeyword][$containsi]=${searchQryy}`;
        searchQryFilter = `&${searchQry}`;
        //  setCurrentPage(1)
      }
      let datefilter = '';
      let updateddatefilter = '';

      const today = new Date();
      const startOfToday = new Date(today.setHours(0, 0, 0, 0)); // Set time to 00:00:00
      const endOfToday = new Date(); // Current time

      switch (selectedDateRange) {
        case 'Today':
          datefilter = `filters[createdAt][$gte]=${formatDateToISO(
            startOfToday
          )}&filters[createdAt][$lte]=${formatDateToISO(endOfToday)}`;
          break;

        case 'Yesterday':
          const yesterday = new Date();
          yesterday.setDate(today.getDate() - 1);
          datefilter = `filters[createdAt][$eq]=${formatDateToISO(yesterday)}`;
          break;

        case 'This week':
          datefilter = `filters[createdAt][$gte]=${getFirstDayOfWeek(today)}`;
          break;

        case 'Last week':
          const lastWeekStart = new Date(today);
          lastWeekStart.setDate(today.getDate() - today.getDay() - 7); // Start of last week
          datefilter = `filters[createdAt][$gte]=${formatDateToISO(
            lastWeekStart
          )}&filters[createdAt][$lte]=${getFirstDayOfWeek(today)}`;
          break;

        case 'This month':
          datefilter = `filters[createdAt][$gte]=${getFirstDayOfMonth(today)}`;
          break;

        case 'Last month':
          datefilter = `filters[createdAt][$gte]=${getFirstDayOfLastMonth(
            today
          )}&filters[createdAt][$lte]=${getLastDayOfLastMonth(today)}`;
          break;

        case 'Last 3 month':
          const threeMonthsAgo = new Date(today);
          threeMonthsAgo.setMonth(today.getMonth() - 3);
          datefilter = `filters[createdAt][$gte]=${formatDateToISO(threeMonthsAgo)}`;
          break;

        case 'Last 6 month':
          const sixMonthsAgo = new Date(today);
          sixMonthsAgo.setMonth(today.getMonth() - 6);
          datefilter = `filters[createdAt][$gte]=${formatDateToISO(sixMonthsAgo)}`;
          break;

        default: // Or handle the default case as needed
          datefilter = '';
          break;
      }

      switch (selectedUpdatedDateRange) {
        case 'Today':
          updateddatefilter = `&filters[updatedAt][$gte]=${formatDateToISO(
            startOfToday
          )}&filters[updatedAt][$lte]=${formatDateToISO(endOfToday)}`;
          break;

        case 'Yesterday':
          updateddatefilter = `&filters[updatedAt][$eq]=${getDateDaysAgo(today, 1)}`;
          break;

        case 'This week':
          updateddatefilter = `&filters[updatedAt][$gte]=${getFirstDayOfWeek(today)}`;
          break;

        case 'Last week':
          const lastWeekStart = new Date(today);
          lastWeekStart.setDate(today.getDate() - today.getDay() - 7); // Start of last week
          updateddatefilter = `&filters[updatedAt][$gte]=${formatDateToISO(
            lastWeekStart
          )}&filters[updatedAt][$lte]=${getFirstDayOfWeek(today)}`;
          break;

        case 'This month':
          updateddatefilter = `&filters[updatedAt][$gte]=${getFirstDayOfMonth(today)}`;
          break;

        case 'Last month':
          updateddatefilter = `&filters[updatedAt][$gte]=${getFirstDayOfLastMonth(
            today
          )}&filters[updatedAt][$lte]=${getLastDayOfLastMonth(today)}`;
          break;

        case 'Last 3 month':
          const threeMonthsAgo = new Date(today);
          threeMonthsAgo.setMonth(today.getMonth() - 3);
          updateddatefilter = `&filters[updatedAt][$gte]=${formatDateToISO(threeMonthsAgo)}`;
          break;

        case 'Last 6 month':
          const sixMonthsAgo = new Date(today);
          sixMonthsAgo.setMonth(today.getMonth() - 6);
          updateddatefilter = `&filters[updatedAt][$gte]=${formatDateToISO(sixMonthsAgo)}`;
          break;

        default: // Or handle the default case as needed
          updateddatefilter = '';
          break;
      }


      // console.log(
      //   `${globalIP}/api/products?populate=*&filters[MaterialCollection][MatCollectionCode][$eq]=${matname}&sort[0]=id:desc&pagination[page]=${currentPage}${categoryFilter}${protypeFilter}${colorFilter}${finishFilter}${hsnFilter}${matFilter}${buyerFilter}${searchFilter}${aliasFilter}${pronFilter}${prodFilter}${madeFilter}${skuFilter}${searchQryFilter}`
      // );
      let showpFilter = `&filters[Authorized][$eq]=Authorised`;
      const response = await fetch(
        `${globalIP}/api/products?populate=*&filters[MaterialCollection][MatCollectionCode][$eq]=${matname}&sort[0]=id:desc&pagination[page]=${currentPage}${categoryFilter}${protypeFilter}${colorFilter}${finishFilter}${hsnFilter}${matFilter}${buyerFilter}${searchFilter}${aliasFilter}${pronFilter}${prodFilter}${madeFilter}${skuFilter}${searchQryFilter}&${updateddatefilter}&${datefilter}${showpFilter}`
      );
      const json = await response.json();
      setLimit(json.data.length);

      if (currentPage === 1) {
        setData123(json.data);
      } else {
        setData123(prevData => [...prevData, ...json.data]);
      }
      setMeta123(json.meta);
      setIsLoadmdata(false);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };

  useEffect(() => {
    fetchDatar();
  }, [currentPage]);

  const [collectiondata, setCollectiondata] = useState([]);
  const [productData, setProductData] = useState({}); // Store product data for each MatCollectionCode
  const [collectionfdata, setCollectionfdata] = useState([]);
  const [selectedColl, setSelectedColl] = useState([]);
  const [colLoading, setColLoading] = useState(false);
  useEffect(() => {
    fetchData();
  }, [selectedColl]);

  useEffect(() => {
    fetchDatac();
  }, []);
  const fetchDatac = async () => {
    try {
      const response = await fetch(
        `${globalIP}/api/mstmaterialcollections?&pagination[page]=1&filters[dis][$ne]=Discontinue`
      );
      const json = await response.json();
      const allData = [];
      for (let page = 1; page <= json.meta.pagination.pageCount; page++) {
        const pageResponse = await fetch(
          `${globalIP}/api/mstmaterialcollections?&pagination[page]=${page}&filters[dis][$ne]=Discontinue`
        );
        const pageJson = await pageResponse.json();
        const processedData = pageJson.data.map(item => ({
          label: item.attributes.MatCollectionName,
          value: item.attributes.MatCollectionCode
        }));
        allData.push(...processedData);
      }
      setCollectionfdata(allData);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };

  const fetchData = async () => {
    if (colLoading) {
      return;
    }
    setColLoading(true);
    try {
      let collFilter = '';
      if (selectedColl.length > 0) {
        const collFilterString = selectedColl
          .map(cat => `filters[MatCollectionCode][$eq]=${cat}`)
          .join('&');
        collFilter = `&${collFilterString}`;
      }
      const collectionResponse = await fetch(
        `${globalIP}/api/mstmaterialcollections?populate=*${collFilter}&filters[dis][$ne]=Discontinue`
      );
      const collectionJson = await collectionResponse.json();
      setCollectiondata(collectionJson.data);
      // Fetch product data for each MatCollectionCode
      const productDataPromises = collectionJson.data.map(async collection => {
        let showpFilter = `&filters[Authorized][$eq]=Authorised`;
        const response = await fetch(
          `${globalIP}/api/products?populate=*&filters[MaterialCollection][MatCollectionCode][$eq]=${collection.attributes.MatCollectionCode}${showpFilter}`
        );
        const json = await response.json();
        return { [collection.attributes.MatCollectionCode]: json.data };
      });
      const products = await Promise.all(productDataPromises);
      // Combine product data for all MatCollectionCodes into a single object
      const mergedProductData = Object.assign({}, ...products);
      setProductData(mergedProductData);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
    setColLoading(false);
  };
  const handleCollChange = value => {
    setSelectedColl(value);
  };

  ///// filters //////

  const [categorydata, setCategorydata] = useState([]);
  const [isLoadingc, setIsLoadingc] = React.useState(false);
  useEffect(() => {
    fetchCategory(setCategorydata, isLoadingc, setIsLoadingc);
  }, []);

  const [colordata, setColordata] = React.useState([]);
  const [isLoadingcolor, setIsLoadingcolor] = React.useState(false);
  useEffect(() => {
    fetchColors(setColordata, isLoadingcolor, setIsLoadingcolor);
  }, []);

  const [productypedata, setProductypedata] = useState([]);
  const [isLoadingpro, setIsLoadingpro] = useState(false);
  useEffect(() => {
    if (selectedCategoryCode) {
      fetchProductTypes(
        setProductypedata,
        isLoadingpro,
        selectedCategoryCode,
        setIsLoadingpro,
        selectedCategory
      );
    }
  }, [selectedCategoryCode, selectedCategory]);

  const [buyernamedata, setBuyerNamedata] = useState([]);
  const [isLoadingbu, setIsLoadingbu] = useState(false);
  useEffect(() => {
    fetchBuyers(setBuyerNamedata, isLoadingbu, setIsLoadingbu);
  }, []);

  const [searchdata, setSearchdata] = useState([]);
  const [isLoadingse, setIsLoadingse] = useState(false);
  useEffect(() => {
    fetchSearchKeyword(setSearchdata, isLoadingse, setIsLoadingse);
  }, []);

  const [proNamedata, setProdNamedata] = useState([]);
  const [isLoadingpron, setIsLoadingpron] = useState(false);
  useEffect(() => {
    fetchProductName(setProdNamedata, isLoadingpron, setIsLoadingpron);
  }, []);

  const [proDdata, setProdDdata] = useState([]);
  const [isLoadingprod, setIsLoadingprod] = useState(false);
  useEffect(() => {
    fetchProductDesign(setProdDdata, isLoadingprod, setIsLoadingprod);
  }, []);

  const [madedata, setMadedata] = useState([]);
  const [isLoadingmade, setIsLoadingmade] = useState(false);
  useEffect(() => {
    fetchMadeBy(setMadedata, isLoadingmade, setIsLoadingmade);
  }, []);

  const [finishdata, setFinishData] = React.useState([]);
  const [isLoadingfin, setIsLoadingfin] = React.useState(false);
  useEffect(() => {
    fetchFinishes(setFinishData, isLoadingfin, setIsLoadingfin);
  }, []);

  const [aliasdata, setAliasdata] = useState([]);
  const [isLoadingalias, setIsLoadingalias] = useState(false);
  useEffect(() => {
    fetchAlias(setAliasdata, isLoadingalias, setIsLoadingalias);
  }, []);

  const [skudata, setSkudata] = useState([]);
  const [isLoadingsku, setIsLoadingsku] = useState(false);
  useEffect(() => {
    fetchSkuUnique(setSkudata, isLoadingsku, setIsLoadingsku);
  }, []);

  const [hsndata, setHsndata] = React.useState([]);
  const [isLoadinghsn, setIsLoadinghsn] = React.useState(false);
  useEffect(() => {
    fetchHsn(setHsndata, isLoadinghsn, setIsLoadinghsn);
  }, []);

  const handleFilterChange = (
    filterType,
    value,
    prevValue,
    clearSearchQuery,
    setClearSearchQuery
  ) => {
    const tempsearchq = searchQuery;
    setSearchQuery(''); // Clear the search query first

    const anyOtherFilterSelected =
      selectedCategory.length > 0 ||
      selectedProductType.length > 0 ||
      selectedColor.length > 0 ||
      selectedFinish.length > 0 ||
      selectedhsn.length > 0 ||
      selectedmaterial.length > 0 ||
      selectedBuyer.length > 0 ||
      selectedSearch.length > 0 ||
      selectedAlias.length > 0 ||
      selectedpron.length > 0 ||
      selectedpd.length > 0 ||
      selectedmade.length > 0 ||
      selectedsku.length > 0;

    // Handle setting clearSearchQuery flag
    if (anyOtherFilterSelected || prevValue.length === 0) {
      setClearSearchQuery(true);
    } else {
      setClearSearchQuery(false);
      setSearchQuery(tempsearchq);
    }

    // Set the filter state for the specific filter type
    switch (filterType) {
      case 'category':
        setSelectedCategory(value);
        break;
      case 'productType':
        setSelectedProductType(value);
        break;
      case 'color':
        setSelectedColor(value);
        break;
      case 'finish':
        setSelectedFinish(value);
        break;
      case 'hsn':
        setSelectedhsn(value);
        break;
      case 'material':
        setSelectedmaterial(value);
        break;
      case 'buyer':
        setSelectedBuyer(value);
        break;
      case 'search':
        setSelectedSearch(value);
        break;
      case 'alias':
        setSelectedAlias(value);
        break;
      case 'productName':
        setSelectedPron(value);
        break;
      case 'productDescription':
        setSelectedProd(value);
        break;
      case 'made':
        setSelectedMade(value);
        break;
      case 'sku':
        setSelectedSku(value);
        break;
      default:
        break;
    }

    // Reset pagination
    //  setPage(1);
    setCurrentPage(1);

    // Refetch data only after search query is cleared
    //  setReload((prev) => !prev);
  };
  // Update individual handlers
  const handleCategoryChange = value => {
    handleFilterChange('category', value, selectedCategory, clearSearchQuery, setClearSearchQuery);
  };
  const handleProductTypeChange = value => {
    handleFilterChange(
      'productType',
      value,
      selectedProductType,
      clearSearchQuery,
      setClearSearchQuery
    );
  };
  const handleColorChange = value => {
    handleFilterChange('color', value, selectedColor, clearSearchQuery, setClearSearchQuery);
  };
  const handleFinishChange = value => {
    handleFilterChange('finish', value, selectedFinish, clearSearchQuery, setClearSearchQuery);
  };
  const handleHSNChange = value => {
    handleFilterChange('hsn', value, selectedhsn, clearSearchQuery, setClearSearchQuery);
  };
  const handleMaterialChange = value => {
    handleFilterChange('material', value, selectedmaterial, clearSearchQuery, setClearSearchQuery);
  };
  const handleBuyerChange = value => {
    handleFilterChange('buyer', value, selectedBuyer, clearSearchQuery, setClearSearchQuery);
  };
  const handleSearchChange = value => {
    handleFilterChange('search', value, selectedSearch, clearSearchQuery, setClearSearchQuery);
  };
  const handleAliasChange = value => {
    handleFilterChange('alias', value, selectedAlias, clearSearchQuery, setClearSearchQuery);
  };
  const handleProNameChange = value => {
    handleFilterChange('productName', value, selectedpron, clearSearchQuery, setClearSearchQuery);
  };
  const handleProDChange = value => {
    handleFilterChange(
      'productDescription',
      value,
      selectedpd,
      clearSearchQuery,
      setClearSearchQuery
    );
  };
  const handleMadeChange = value => {
    handleFilterChange('made', value, selectedmade, clearSearchQuery, setClearSearchQuery);
  };
  const handleSkuChange = value => {
    handleFilterChange('sku', value, selectedsku, clearSearchQuery, setClearSearchQuery);
  };

  useEffect(() => {
    if (inView && limit) {
      setCurrentPage(prev => prev + 1);
    }
  }, [inView]);
  const [showDrawer, setShowDrawer] = useState(false);
  const [head, setHead] = useState([]);
  useEffect(() => {
    fetchHeads(setHead);
  }, []);
  // useFilter(
  //   selectedCategory,
  //   selectedProductType,
  //   selectedColor,
  //   selectedFinish,
  //   selectedAlias,
  //   setAliasdata,
  //   setFinishData,
  //   setColordata,
  //   setCategorydata,
  //   setProductypedata
  // );
  console.log(categorydata)
  const items = [
    { key: "content1", label: "All Products" },
    { key: "content2", label: label[0]?.attributes?.Collection },
    { key: "content3", label: "Image Edit" },
    { key: "content4", label: "Variant Products" },
    { key: "content5", label: "Space Visualization" },
  ];
  return (
    <>
      <div
        style={{
          justifyContent: 'space-between',
          width: '-webkit-fill-available',
          position: 'fixed',
          height: '180px',
          background: '#fff',
          zIndex: 1
        }}
      >
        <Stack className="table-toolbar product-head" justifyContent="space-between">
          <Stack direction="column" alignItems="flex-start">
            <Stack direction="column" alignItems="flex-start" className="product-det">
              <Stack direction="row" alignItems="flex-start" spacing={157} onClick={handlePanelToggleBack}>
                {/* <NavD activeKey={activeKey} handleNavSelect={handleNavSelect} label={label} /> */}
              </Stack>
              <Breadcrumb>
                <Breadcrumb.Item>
                  <Link to={`/${ugr}/dashboard`}>Home</Link>
                </Breadcrumb.Item>
                <Breadcrumb.Item
                  active={activeKey === 'content1'}
                  onClick={() => handleNavSelect('content1')}
                >
                  Product
                </Breadcrumb.Item>
                <Breadcrumb.Item
                  active={activeKey === 'content2'}
                  onClick={() => handleNavSelect('content2')}
                >
                  Library
                </Breadcrumb.Item>
              </Breadcrumb>

              {/* <Breadcrumb>
                <Breadcrumb.Item>
                  <Link to={`/${ugr}/dashboard`}>Home</Link>
                </Breadcrumb.Item>
                <Breadcrumb.Item active>
                  <Link to={`/${ugr}/products`}>Products</Link>
                </Breadcrumb.Item>
                <Breadcrumb.Item>
                  <Link to={`/${ugr}/manageCollection`}>Library</Link>
                </Breadcrumb.Item>
              </Breadcrumb> */}
            </Stack>

            {showPanel ? (
              <div className='d-flex align-items-center gap-2'>
                <Dropdown
                  menu={{
                    items,
                    onClick: ({ key }) => handleNavSelect(key),
                  }}
                  trigger={["click"]}
                >
                  <Button>
                    View <EyeFilled />
                  </Button>
                </Dropdown>
                <CheckPicker
                  data={collectionfdata}
                  style={{ width: 150 }}
                  value={selectedColl}
                  onChange={handleCollChange}
                  placeholder="Select Collection"
                />
              </div>
            ) : (
              <>
                <Stack spacing={5}>
                  {/* <Button onClick={handlePanelToggleBack} active>
                    <UndoIcon />
                  </Button> */}
                  <HeaderFilter
                    {...{
                      head,
                      label,
                      //data states
                      categorydata,
                      productypedata,
                      colordata,
                      proNamedata,
                      skudata,
                      buyernamedata,
                      finishdata,
                      aliasdata,
                      searchdata,
                      proDdata,
                      madedata,
                      hsndata,
                      // materialdata,
                      setCategorydata,
                      // setIsLoadingc,
                      // isLoadingc,
                      // SetIsLoadingTableData,
                      // setProgress,
                      setColordata,
                      isLoadingcolor,
                      setIsLoadingcolor,
                      setFinishData,
                      isLoadingfin,
                      setIsLoadingfin,
                      setHsndata,
                      isLoadinghsn,
                      setIsLoadinghsn,
                      //selectedstates
                      selectedCategory,
                      selectedProductType,
                      selectedColor,
                      selectedpron,
                      selectedsku,
                      selectedBuyer,
                      selectedFinish,
                      selectedAlias,
                      selectedSearch,
                      selectedpd,
                      selectedmade,
                      selectedhsn,
                      selectedmaterial,

                      selectedDateRange,
                      selectedUpdatedDateRange,
                      handleDatechange,
                      handleUpdatedDatechange,
                      handleCategoryChange,
                      handleProductTypeChange,
                      handleColorChange,
                      handleProNameChange,
                      handleSkuChange,
                      handleBuyerChange,
                      handleFinishChange,
                      handleAliasChange,
                      handleSearchChange,
                      handleProDChange,
                      handleMadeChange,
                      handleHSNChange,
                      handleMaterialChange,
                      //onopenfunctions
                      fetchCategory,
                      fetchColors,
                      fetchFinishes,
                      fetchProductTypes,
                      fetchAlias
                      //rendermenus
                      // renderMenu2,
                      // renderMenu5,
                      // renderMenu1,
                      // renderMenu,
                      // renderMenu3,
                      // renderMenu4
                    }}
                  />
                  <Button appearance="default" active onClick={() => setShowDrawer(true)}>
                    More Filter
                  </Button>
                </Stack>
              </>
            )}
          </Stack>
          {showSearch && (
            <Stack
              alignItems="flex-end"
              spacing={24}
              // style={{ marginBottom: '-40px' }}
              className="mange-search quotation-srchbar "
            >
              <Stack direction="row" spacing={5} className="create-q">
                <InputGroup inside>
                  {/* <Input
                    placeholder="Search"
                    type="text"
                    value={searchQuery}
                    onChange={handleSearch}
                  /> */}
                  <Input
                    placeholder="Search"
                    type="text"
                    value={searchQuery}
                    onChange={value => {
                      setSearchQuery(value);
                    }}
                  // onKeyDown={event => {
                  //   if (event.key === 'Enter') {
                  //     setSearchQryBtn = true
                  //     searchQry();
                  //   }
                  // }}
                  />
                  <InputGroup.Addon>
                    <SearchIcon
                      onClick={() => {
                        // setSearchQryBtn = true
                        // searchQry();
                      }}
                      style={{ cursor: 'pointer' }}
                    />
                  </InputGroup.Addon>
                </InputGroup>
              </Stack>
            </Stack>
          )}
        </Stack>

        <Divider style={{ marginTop: '5px', marginBottom: '5px' }} />
      </div>
      {showPanel ? (
        <>
          {colLoading ? (
            <Loader speed="fast" center content="loading..." vertical />
          ) : (
            <FlexboxGrid justify="start" style={{ marginTop: "180px" }} className="datatbl-img">
              {console.log(collectiondata)}
              {collectiondata.map((item) => {
                const products = productData[item.attributes.MatCollectionCode] || [];
                const hasImages = products.some(
                  (p) => p.attributes?.CoverImage?.data?.attributes?.url
                );

                return (
                  <FlexboxGrid.Item
                    as={Col}
                    colspan={24}
                    md={6}
                    className="data-tbl-img"
                    key={item.id}
                  >
                    <Panel
                      bordered
                      style={{
                        marginTop: "5px",
                        borderRadius: "0",
                        minHeight: "420px", // ✅ fixed card height
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                      }}
                    >
                      <div>
                        <h2
                          style={{
                            fontSize: "21px",
                            fontFamily: "raleway",
                            minHeight: "50px",
                            marginTop: "0px"
                          }}
                        >
                          {item.attributes.MatCollectionName}{" "}
                          {`(${products.length || 0})`}
                        </h2>

                        {hasImages && (
                          <Stack spacing={5} justifyContent="center">
                            <FlexboxGrid justify="space-between">
                              {products.slice(0, 4).map((product) => (
                                <FlexboxGrid.Item as={Col} colspan={24} md={12} key={product.id}>
                                  <div
                                    style={{
                                      textAlign: "center",
                                      marginBottom: "10px",
                                    }}
                                  >
                                    <div
                                      style={{
                                        width: "100%",
                                        height: "120px", // ✅ fixed height
                                        backgroundColor: "#f2f2f2",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        borderRadius: "4px",
                                        overflow: "hidden",
                                      }}
                                    >
                                      {product.attributes?.CoverImage?.data?.attributes?.url ? (
                                        <img
                                          src={`${globalIP}${product.attributes.CoverImage.data.attributes.url}`}
                                          alt="Product"
                                          style={{
                                            width: "100%",
                                            height: "100%",
                                            objectFit: "cover", // ✅ full cover
                                          }}
                                        />
                                      ) : (
                                        <span
                                          style={{
                                            fontSize: "12px",
                                            color: "#999",
                                            fontFamily: "raleway",
                                          }}
                                        >
                                          No Image
                                        </span>
                                      )}
                                    </div>
                                    <p
                                      style={{
                                        fontSize: "12px",
                                        fontFamily: "raleway",
                                        marginBottom: "5px",
                                        marginTop: "5px",
                                      }}
                                    >
                                      {product.attributes.ProductName}
                                    </p>
                                  </div>
                                </FlexboxGrid.Item>
                              ))}
                            </FlexboxGrid>
                          </Stack>
                        )}
                      </div>

                      {hasImages && (
                        <p
                          style={{
                            fontSize: "15px",
                            color: "#007185",
                            fontFamily: "sans-serif serif",
                            cursor: "pointer",
                            float: "right",
                          }}
                          onClick={() => handlePanelToggle(item.attributes.MatCollectionCode, item.attributes.MatCollectionName)}
                        >
                          See all
                        </p>
                      )}
                    </Panel>
                  </FlexboxGrid.Item>
                );
              })}
            </FlexboxGrid>

          )}
        </>
      ) : (
        <>
          <Panel style={{ marginTop: '168px' }}>
            <h3>
              {matTitle}
            </h3>
            {(selectedCategory.length > 0 ||
              selectedProductType.length > 0 ||
              selectedColor.length > 0 ||
              selectedFinish.length > 0 ||
              selectedhsn.length > 0 ||
              selectedmaterial.length > 0 ||
              selectedBuyer.length > 0 ||
              selectedSearch.length > 0 ||
              selectedAlias.length > 0 ||
              selectedpron.length > 0 ||
              selectedpd.length > 0 ||
              selectedmade.length > 0 ||
              // searchQryBtn ||
              selectedsku.length > 0) && (
                <b style={{ marginLeft: '6px' }}>
                  Total Products: {data123.length}/{meta123.pagination.total}
                </b>
              )}

            {/* {searchQuery && (
              <b style={{ marginLeft: '6px' }}>Found Products: {foundProductCount}</b>
            )} */}

            {selectedCategory.length === 0 &&
              selectedProductType.length === 0 &&
              selectedColor.length === 0 &&
              selectedFinish.length === 0 &&
              selectedhsn.length === 0 &&
              selectedmaterial.length === 0 &&
              selectedBuyer.length === 0 &&
              selectedSearch.length === 0 &&
              selectedAlias.length === 0 &&
              selectedpron.length === 0 &&
              selectedpd.length === 0 &&
              selectedmade.length === 0 &&
              selectedsku.length === 0 &&
              meta123 && (
                <b style={{ marginLeft: '6px' }}>
                  Products: {data123.length}/{meta123.pagination.total}
                </b>
              )}

            <FlexboxGrid justify="start" style={{ textAlign: 'center', marginTop: "20px" }} className="datatbl-img">
              {data123.map(item => (
                <ProductCard
                  {...{
                    item,
                    label,
                    // dataGrid,
                    // productUpdate,
                    pid: () => {
                      history(
                        `/${ugr}/products-create?pId=${item.id}&id=${item.attributes.ProductCode}`
                      );
                    },
                    showCheckbox: 0, // null means no preference, 0 for editicon ,1 for checkbox
                    showEditIcon: 0, // null means no preference, 0 for editicon ,1 for checkbox
                    showVariant: 0, // null means no preference, 0 for variant label ,1 for variant modal button
                    showQuickView: 0 // null means no preference, 0 = only product details ,1= quickview and product deatails
                  }}
                />
              ))}
            </FlexboxGrid>
          </Panel>
          <Button ref={ref} style={{ visibility: 'hidden' }}></Button>
        </>
      )}
      <FilterDrawer
        {...{
          showDrawer,
          setShowDrawer,
          head,
          label,
          //data states
          categorydata,
          productypedata,
          colordata,
          proNamedata,
          skudata,
          buyernamedata,
          finishdata,
          aliasdata,
          searchdata,
          proDdata,
          madedata,
          hsndata,
          // materialdata,
          setCategorydata,
          // setIsLoadingc,
          // isLoadingc,
          // SetIsLoadingTableData,
          // setProgress,
          setColordata,
          isLoadingcolor,
          setIsLoadingcolor,
          setFinishData,
          isLoadingfin,
          setIsLoadingfin,
          setHsndata,
          isLoadinghsn,
          setIsLoadinghsn,
          // setMaterialdata,
          // isLoadingmat,
          // setIsLoadingmat,
          //selectedstates
          selectedCategory,
          selectedProductType,
          selectedColor,
          selectedpron,
          selectedsku,
          selectedBuyer,
          selectedFinish,
          selectedAlias,
          selectedSearch,
          selectedpd,
          selectedmade,
          selectedhsn,
          selectedmaterial,

          selectedDateRange,
          selectedUpdatedDateRange,
          handleDatechange,
          handleUpdatedDatechange,
          handleCategoryChange,
          handleProductTypeChange,
          handleColorChange,
          handleProNameChange,
          handleSkuChange,
          handleBuyerChange,
          handleFinishChange,
          handleAliasChange,
          handleSearchChange,
          handleProDChange,
          handleMadeChange,
          handleHSNChange,
          handleMaterialChange,
          //onopenfunctions
          fetchCategory,
          fetchColors,
          fetchFinishes,
          fetchProductTypes,
          fetchAlias,
          fetchHsn,
          fetchMaterials
          //rendermenus
          // renderMenu2,
          // renderMenu5,
          // renderMenu1,
          // renderMenu,
          // renderMenu3,
          // renderMenu4
        }}
      />
    </>
  );
};

export default Library;
